"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _ScreenPlaceholder = require("../../molecules/ScreenPlaceholder");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ChatListNoInternetError = function ChatListNoInternetError(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenPlaceholder.ScreenPlaceholder, {
    title: "Voc\xEA est\xE1 sem Internet no momento",
    text: "N\xE3o foi poss\xEDvel se conectar ao servidor.",
    cta: "Tentar novamente",
    action: onClick
  });
};
ChatListNoInternetError.propTypes = {
  onClick: _propTypes.func.isRequired
};
var _default = exports["default"] = ChatListNoInternetError;